/* Presentation helpers only. Native Craft controls pricing, variants, cart and payment. */
(() => {
  if (window.awProductLayoutBound) return;
  window.awProductLayoutBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('.aw-pdp-detail-nav a') : null;
    if (!link || !link.hash) return;
    const target = document.getElementById(link.hash.slice(1));
    if (target && target.tagName === 'DETAILS') target.open = true;
  });
  const init = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!data || !data.variant) return;
      const info = document.getElementById(`MainProduct-${data.sectionId}`);
      if (!info || !info.closest('.aw-product-layout')) return;
      const variant = data.variant;
      info.querySelectorAll('.aw-product-quote-link').forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('sku', variant.sku || '');
        link.href = url.toString();
      });
      const details = document.getElementById(`AwProductDetails-${info.dataset.productId}`);
      const specs = details?.querySelector('[data-aw-quick-specs]');
      if (!specs) return;
      const label = specs.dataset.skuLabel;
      const rows = Array.from(specs.querySelectorAll('.aw-specs__grid > div'));
      let row = rows.find((item) => item.querySelector('dt')?.textContent.trim() === label);
      if (!row && variant.sku) {
        row = document.createElement('div');
        const dt = document.createElement('dt');
        dt.textContent = label;
        row.append(dt, document.createElement('dd'));
        specs.querySelector('.aw-specs__grid')?.prepend(row);
      }
      if (row) {
        row.hidden = !variant.sku;
        row.style.display = variant.sku ? '' : 'none';
        const value = row.querySelector('dd');
        if (value) value.textContent = variant.sku || '';
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
